function throttle(callback, limit, leading = false) {
    let waiting = false;
    let leadingId = null;

    return function () {
        if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;

            if (leadingId) {
                clearTimeout(leadingId);
            }

            setTimeout(function () {
                waiting = false;

                // Force one last call after all throttling has been done.
                // Helps to avoid situation where last event must always fire with the latest value like window resize.
                if (leading) {
                    leadingId = setTimeout(() => {
                        callback.apply(this, arguments);
                    }, limit);
                }
            }, limit);
        }
    };
}

export {
    throttle,
};
